module.exports = __webpack_public_path__ + "static/media/compare1.54f082e3.gif";